module.exports = __webpack_public_path__ + "img/teca-logo.320b7f97.png";